<template>
    <basic-card>
        <template slot="header">
            Operation link definitions
        </template>
        <data-table
                :configuration="operationLinkTableConfiguration"
                :data="operationLinkDefinitions"
                component-id="operation-link-table"
                @add="handleAdd"
                @focusedChanged="focusedChanged"
            >
            <basic-card v-if="focusedLink != null">
                <template slot="header">
                    Operation link
                </template>

                <form-wrapper form-title="Link definition">
                    <form-text-input caption="Link name" v-model="focusedLink.name"/>
                    <form-select-input caption="Cardinality" v-model="focusedLink.cardinality" :options="cardinalityOptions"/>
                    <form-checkbox-input caption="Cascade delete" v-model="focusedLink.cascadeDelete"/>
                </form-wrapper>
                <form-wrapper form-title="Primary side">
                    <form-text-input caption="Primary side name" v-model="focusedLink.primarySideName"/>
                    <form-multi-select-input caption="Primary side op. definitions" :options="operationDefinitions" v-model="focusedLink.primaryOperationDefinitions"/>
                </form-wrapper>
                <form-wrapper form-title="Secondary side">
                    <form-text-input caption="Secondary side name" v-model="focusedLink.secondarySideName"/>
                    <form-multi-select-input caption="Secondary side op. definitions" :options="operationDefinitions" v-model="focusedLink.secondaryOperationDefinitions"/>
                </form-wrapper>
                <simple-button @press="handleSave">
                    Save
                </simple-button>
            </basic-card>
        </data-table>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import FormWrapper from "../components/form/FormWrapper";
    import SimpleButton from "../components/button/SimpleButton";
    import FormTextInput from "../components/form/FormTextInput";
    import FormSelectInput from "../components/form/FormSelectInput";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    import FormMultiSelectInput from "../components/form/FormMultiSelectInput";
    import {mapGetters} from "vuex";
    export default {
        name: "OperationLinkDefinitionsView",
        components: {
            FormMultiSelectInput,
            FormCheckboxInput, FormSelectInput, FormTextInput, SimpleButton, FormWrapper, DataTable, BasicCard},
        data: function() {
            return {
                focusedLink: null,
                cardinalityOptions: [
                    {name: "1:1", id: "ONE_TO_ONE"},
                    {name: "1:N", id: "ONE_TO_MANY"},
                    {name: "N:1", id: "MANY_TO_ONE"}
                ],
                operationLinkTableConfiguration: {
                    enableAdd: true,
                    allowEdit: true,
                    selectionMode: 'single',
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: "Link name",
                            datum: d => d.name
                        },
                        {
                            caption: "Cardinality",
                            datum: d => this.cardinalityOptions.find(cardinality => cardinality.id == d.cardinality)?.name ?? "N/A"
                        },
                        {
                            caption: "Primary side name",
                            datum: d => d.primarySideName
                        },
                        {
                            caption: "Secondary side name",
                            datum: d => d.secondarySideName
                        }
                    ]
                }
            }
        },
        computed: {
            ... mapGetters({
                "operationLinkDefinitions": "operationLinkDefinitions/operationLinkDefinitions",
                "operationDefinitions": "operationDefinitions/operationDefinitions"
            })
        },
        methods: {
            handleAdd() {
                this.focusedLink = {
                    primaryOperationDefinitions: [],
                    secondaryOperationDefinitions: [],
                }
            },
            handleSave() {
                this.$store.dispatch("operationLinkDefinitions/saveOperationLinkDefinition", this.focusedLink)
                    .then(() => {
                        this.$notify({
                            group: 'application',
                            title: 'Operation link definition was saved',
                            text: `Operation link definition was successfully saved`,
                            type: "ok"
                        });
                    })
            },
            focusedChanged(newFocused) {
                this.focusedLink = newFocused;
            }
        },
        mounted() {
            this.$store.dispatch("operationLinkDefinitions/refreshOperationLinkDefinitions")
        }
    }
</script>

<style scoped>

</style>